import React from "react";

interface TopbarProps {
  activePage: string;
  onMenuToggle?: () => void;
}

const Topbar: React.FC<TopbarProps> = ({ activePage, onMenuToggle }) => {
  return (
    <header className="admin-topbar">
      <div className="topbar-left">
        {onMenuToggle && (
          <button className="topbar-menu-toggle" onClick={onMenuToggle} aria-label="Toggle Menu">
            <i className="fa-solid fa-bars" />
          </button>
        )}
        <div className="topbar-brand">
          <img
            src="/logo.png"
            alt="École des Ponts Logo"
            className="topbar-logo"
          />
          <h1 className="topbar-title">École des Ponts Admin</h1>
        </div>
        <div className="topbar-breadcrumb">
          <i className="fa-solid fa-house breadcrumb-home" title="Home" />
          <i className="fa-solid fa-chevron-right breadcrumb-separator" />
          <span className="breadcrumb-active">{activePage}</span>
        </div>
      </div>
      <div className="topbar-right">
        {/* Right side items can be added here in the future if needed */}
      </div>
    </header>
  );
};

export default Topbar;
